import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

import { UIControllerProvider } from "context";

// Apply CSS styles but without global overflow hidden
import "./assets/css/index.css";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <BrowserRouter>
    <UIControllerProvider>
      <App />
    </UIControllerProvider>
  </BrowserRouter>,
);

